module.exports = __webpack_public_path__ + "static/img/bg.53c1c87.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/activity4/bg.jpg
// module id = r9lL
// module chunks = 7